import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('ui-components-FileUpload', [
  'submittedFile',
  'playButton',
  'closePlayerButton',
  'player',
]);
